import React, { useState,useEffect } from 'react'
import Api from '../../../services/api'
import Alert from '../../../Components/alert/Alert'
import '../general.css'
import CommonButton from '../../../Components/commonButton/commonButton'
import DatePicker from "../../../Components/datePicker/datePicker";
import TableList from "../../../Components/tableListHolidays/TableList";
import MessageTable from "../../../Components/messageTable/MessageTable";

const AltDay = () => {
    let dateAux = new Date();
    dateAux = dateAux.getFullYear() + "-" + (dateAux.getMonth() + 1 < 10 ? "0" + parseInt(dateAux.getMonth() + 1): 
    dateAux.getMonth() + 1 ) + "-" + (dateAux.getDate() < 10 ? "0" + parseInt(dateAux.getDate()) : dateAux.getDate());
    const [origin_date, setOriginDate] = useState(dateAux);
    const [changed_date, setChangedDate] = useState(dateAux);
    const [show, setShow] = useState(false);
    const [message, setMessage] = useState("");
    const [dataFilter, setDataFilter] = useState([]);
    const [reload, setReload] = useState(false);
    const [loading, setLoading] = useState(true);

    const callbackfunction = () => {
        setShow(false);
    }

    useEffect(()=>{
        Api.get('/work-shifts/get-holidays').then(resp=>{
            if(resp.data){
                setDataFilter(resp.data);
            }
        });
    },[]);

    useEffect(()=>{
        setLoading(false);
      },[dataFilter])

    const saveInitialDate = (value) => {
        let day = value.substr(0, 2)
        let month = value.substr(3, 2)
        let year = value.substr(6, 7)
        setOriginDate(year + "-" + month + "-" + day);
    }

    const saveFinalDate = (value) => {
        let day = value.substr(0, 2)
        let month = value.substr(3, 2)
        let year = value.substr(6, 7)
        setChangedDate(year + "-" + month + "-" + day);
    }

    const sendData = () => {
        if (origin_date !== changed_date) {
            Api.post('/work-shifts/alt-day', { origin_date: origin_date, changed_date: changed_date }).then((response) => {
                if (response.status == 201 || response.status == 200 ) {
                    localStorage.setItem("@oee-monitor/notification", "Troca feita com sucesso!");
                    localStorage.setItem("@oee-monitor/notification-type", "success");
                    return window.location.reload();
                }
            }).catch(err => {
                if (err.response.status == 400) {
                    setShow(true);
                    setMessage(err.response.data.message);
                }
            });
        } else {
            setShow(true);
            setMessage("A data de origem e a final devem ser diferentes !");
        }
    }

    return (
        <div className="box">
            <div className="mot_del_reason form" >
                <h4>Trocar dia</h4>
                {show ? <Alert show={show} message={message} parentCallback={callbackfunction} reload={reload} /> : null}
                <div className='inputs'>
                    <div className='element'><DatePicker name="origin_date" title="Data original" parentCallback={saveInitialDate} value={origin_date} /></div>
                    <div className='element'><DatePicker name="changed_date" title="Data de troca" parentCallback={saveFinalDate} value={changed_date} /></div>
                </div>
                <div className='btnDelWorkShift submitButton'><CommonButton title="Trocar" parentCallback={sendData} /></div>
                <br/>
                <div style={{width: "100%", display: "flex", alignItems: "center", flexDirection: "column"}}>
                {dataFilter.length > 0 ? (<span>{`Clique no registro para ser deletado.`}</span>):null}
                    {dataFilter.length > 0 ? (
                        <TableList compValue={"id"} data={dataFilter}></TableList>
                    ) : (
                        <MessageTable message={"Sem dados para processar."} />
                    )}  
                </div>
                
            </div>
        </div>
    );
}

export default AltDay;